let fBox_data = [
    {
        type: '공용 테니스',
        name: 'F-Box 컬렉션 우븐 바람막이',
        price: '149,000원',
        imgUrl: '/img/fBox1.jpg'
    },
    {
        type: '공용 테니스',
        name: 'F-Box 컬렉션 우븐 조거팬츠',
        price: '129,000원',
        imgUrl: '/img/fBox2.jpg'
    },
    {
        type: '여성 테니스',
        name: 'F-Box 컬렉션 니트 베스트',
        price: '129,000원',
        imgUrl: '/img/fBox3.jpg'
    },
    {
        type: '여성 테니스',
        name: 'F-Box 컬렉션 니트 베스트',
        price: '169,000원',
        imgUrl: '/img/fBox4.jpg'
    },
    {
        type: '여성 테니스',
        name: 'F-Box 컬렉션 여성 니트 가디건',
        price: '229,000원',
        imgUrl: '/img/fBox5.jpg'
    },
    {
        type: '공용 테니스',
        name: 'F-Box 컬렉션 V넥 니트 스웨터',
        price: '169,000원',
        imgUrl: '/img/fBox6.jpg'
    },
    {
        type: '공용 테니스',
        name: 'F-Box 컬렉션 니트 디테일 맨투맨',
        price: '149,000원',
        imgUrl: '/img/fBox7.jpg'
    },
    {
        type: '공용 테니스',
        name: 'F-Box 컬렉션 라인 배색 조거팬츠',
        price: '129,000원',
        imgUrl: '/img/fBox8.jpg'
    }
]


export default fBox_data;